export function getItemTypeColors(category?: 'equipment' | 'info' | 'problem' | 'consideration') {
    switch (category) {
        case 'problem':
            return {
                text: 'text-red-600',
                border: 'border-red-700',
                stroke: 'stroke-red-700',
                fill: 'fill-red-600',
            } as const;
        case 'info':
            return {
                text: 'text-green-600',
                border: 'border-green-700',
                stroke: 'stroke-green-700',
                fill: 'fill-green-600',
            } as const;
        case 'equipment':
            return {
                text: 'text-blue-600',
                border: 'border-blue-700',
                stroke: 'stroke-blue-700',
                fill: 'fill-blue-600',
            } as const;
        case 'consideration':
            return {
                text: 'text-purple-600',
                border: 'border-purple-700',
                stroke: 'stroke-purple-700',
                fill: 'fill-purple-600',
            } as const;
        default:
            return {
                text: 'text-gray-600',
                border: 'border-gray-700',
                stroke: 'stroke-gray-700',
                fill: 'fill-gray-600',
            } as const;
    }
}
